import { Control, UseFormRegister, FieldErrors } from "react-hook-form";
import { AsyncSelectField } from "./AsyncSelectField";
import { Select } from "@/components/common/Select";
import { Label } from "@/components/common/FormLabel";
import { ErrorLabel } from "@/components/common/ErrorLabel";
import { AnalysisItem } from "@/types/domain";
import { getFieldErrorMessage } from "@/utils/reactHookForm";

type SelectOption = { value: string; label: string };

type AnalysisItemFieldProps = {
  item: AnalysisItem;
  fieldKey: string;
  control: Control<any>;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  loadOptions: (inputValue: string) => Promise<SelectOption[]>;
};

export const AnalysisItemField = ({ item, fieldKey, control, register, errors, loadOptions }: AnalysisItemFieldProps) => {
  const label = item.fullName || item.shortName;

  if (item.isAutoComplete) {
    return (
      <div>
        <Label forField={fieldKey} label={<>{label} <span className="text-red-500">*</span></>} />
        <AsyncSelectField<SelectOption>
          name={fieldKey}
          control={control}
          rules={{ validate: (val) => !!val || `${label} is required` }}
          inputId={fieldKey}
          loadOptions={loadOptions}
          isClearable
          placeholder="Type to search..."
        />
        <ErrorLabel error={getFieldErrorMessage(errors, fieldKey)} />
      </div>
    );
  }

  const defaultVal = item.defaultCode ?? "";
  return (
    <div>
      <Label forField={fieldKey} label={<>{label} <span className="text-red-500">*</span></>} />
      <Select
        id={fieldKey}
        defaultValue={defaultVal}
        inErrorState={Boolean(errors[fieldKey])}
        {...register(fieldKey, { required: `${label} is required` })}
      >
        <option value="">— Please select —</option>
        {item.values?.map((v) => (
          <option key={v.code} value={v.code}>{v.code} - {v.description}</option>
        ))}
      </Select>
      <ErrorLabel error={getFieldErrorMessage(errors, fieldKey)} />
    </div>
  );
};
